import get from 'lodash/get';
import { useState, useEffect } from 'react';

import styles from '../../../styles/pages/index.module.scss';
import { getCmsPaths } from '../../api/Articles';
import { getLeaflets, getFulladiaLinks } from '../../api/cms';
import CustomMetaHead from '../../components/CustomMetaHead';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import LeafletLayout from '../../components/Leaflets/LeafletLayout';
import Navigation from '../../components/Navigation/Navigation';
import META_DATA from '../../constants/metaData';
import { getOrFetchFooterLinks } from '../../utils/footerLinks';
import { createBreadcrumbJson, getBreadcrumbTwoStep } from '../../utils/getBreadcrumb';
import { getOrFetchNavigationLinks } from '../../utils/navigationLinks';

import pageStyles from './fulladia.module.scss';

export default function Leaflet({ leaflet, navigation, footerLinks, fulladiaLinks, slug, meta }) {
  const [leafletData, setLeafletData] = useState(undefined);

  const breadcrumbData = getBreadcrumbTwoStep(slug);
  const breadcrumb = createBreadcrumbJson(breadcrumbData);

  useEffect(() => {
    setLeafletData(leaflet);
  }, [slug]);

  return (
    <div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumb) }} />
      <CustomMetaHead meta={meta} />
      <header className={styles.headerContainer}>
        <Header navigation={navigation} />
        <Navigation navigation={navigation} />
      </header>
      {leaflet && leaflet[0].fields.sections[0].summary !== 'fulladioflip' && (
        <LeafletLayout leaflet={leafletData} fulladiaLinks={fulladiaLinks} slug={slug} />
      )}
      {leaflet && leaflet[0].fields.sections[0].summary === 'fulladioflip' && (
        <div>
          <iframe
            className={pageStyles.iframe}
            src={leaflet[0].fields.sections[0]['leaflet-url']}
            title="Πλήρες φυλλάδιο"
          />
        </div>
      )}
      <Footer footerLinks={footerLinks} />
    </div>
  );
}

export async function getStaticPaths() {
  const paths = await getCmsPaths('leaflet');
  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  const { slug } = params;
  const [{ data: leaflet }, { data: navigation }, footerLinks, fulladiaLinks] = await Promise.all([
    getLeaflets(`${slug}`),
    getOrFetchNavigationLinks(),
    getOrFetchFooterLinks(),
    getFulladiaLinks(),
  ]);

  const title = get(leaflet, '[0].title');

  const image =
    (leaflet[0]?.fields?.sections &&
      leaflet[0]?.fields?.sections[0]?.cover_image &&
      leaflet[0]?.fields?.sections[0]?.cover_image[0]?.path) ||
    `/assets/${process.env.appName}/logo.png`;

  const meta = {
    ...META_DATA[process.env.appName].fulladia,
    title,
    description: `${title} - Δείτε τις νέες προσφορές! Τα αγαπημένα σας προϊόντα σε super τιμές.`,
    image,
    url: `${process.env.domain}/fulladia/${slug}/`,
  };

  return {
    props: {
      leaflet,
      navigation,
      footerLinks,
      fulladiaLinks,
      slug: `fulladia/${slug}`,
      meta,
    },
  };
}
